import React, { useState } from 'react';
import superagent from 'superagent';
import { backendUrl } from 'helpers/consts';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@shadcn/components/ui/dialog';
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from '@shadcn/components/ui/select';
import { Button } from '@shadcn/components/ui/button';

const timerOptions = [
  { label: '30 minutes', value: '30' },
  { label: '1 hour', value: '60' },
  { label: '2 hours', value: '120' },
  { label: '4 hours', value: '240' },
  { label: '8 hours', value: '480' },
  { label: '24 hours', value: '1440' },
  { label: '48 hours', value: '2880' },
  { label: '1 week', value: '10080' },
  { label: 'Custom', value: 'custom' },
];

const OnHoldWithTimerModal = ({ togglemodal, refresh, orderID, isOpen }) => {
  const [loading, setLoading] = useState(false);
  const [timerDuration, setTimerDuration] = useState('30');
  const [customDateTime, setCustomDateTime] = useState('');

  const calculateUnflagAt = () => {
    if (!timerDuration) return null;

    if (timerDuration === 'custom') {
      if (!customDateTime) return null;
      return new Date(customDateTime);
    }

    const now = new Date();

    // Handle seconds format (e.g., "10s")
    if (timerDuration.endsWith('s')) {
      const seconds = parseInt(timerDuration);
      return new Date(now.getTime() + seconds * 1000);
    }

    // Handle minutes (default)
    return new Date(now.getTime() + parseInt(timerDuration) * 60 * 1000);
  };

  const handleSubmit = () => {
    const unflagAt = calculateUnflagAt();

    if (!unflagAt) {
      alert('Please select a timer duration');
      return;
    }

    const payload = {
      unflagAt: unflagAt,
    };

    setLoading(true);
    superagent
      .post(`${backendUrl}/orders/${orderID}/setOnHoldFlagged`)
      .send(payload)
      .set('Authorization', `Bearer ${localStorage.getItem('authJWT')}`)
      .set('accept', 'json')
      .on('error', (response) => {
        setLoading(false);
      })
      .then((response) => {
        const code = response.status;
        if (code > 400) {
        } else {
          refresh();
          togglemodal();
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  return (
    <Dialog open={isOpen} onOpenChange={togglemodal}>
      {loading === true ? (
        <DialogContent>
          <DialogHeader>
            <DialogTitle>On Hold with Timer</DialogTitle>
          </DialogHeader>
          <div className='flex justify-center'>
            <div className='spinner-border text-primary m-1' role='status'>
              <span className='sr-only'>Loading...</span>
            </div>
          </div>
        </DialogContent>
      ) : (
        <DialogContent>
          <DialogHeader>
            <DialogTitle>On Hold with Timer</DialogTitle>
          </DialogHeader>
          <div className='space-y-4'>
            <div className='bg-blue-50 border border-blue-200 rounded-lg p-3'>
              <p className='text-sm text-blue-800'>
                This will flag the order as "On Hold" and automatically unflag
                it after the selected duration.
              </p>
            </div>

            <div>
              <label className='flex items-center justify-between'>
                <span className='text-sm font-medium text-gray-900'>
                  Auto-unflag Timer
                </span>
                <span className='text-xs text-gray-500'>
                  Default: 30 minutes
                </span>
              </label>
              <Select
                value={timerDuration}
                onValueChange={(value) => setTimerDuration(value)}
              >
                <SelectTrigger className='w-full'>
                  <SelectValue placeholder='Select duration' />
                </SelectTrigger>
                <SelectContent>
                  <SelectGroup>
                    <SelectLabel>Duration</SelectLabel>
                    {timerOptions.map((option) => (
                      <SelectItem key={option.value} value={option.value}>
                        {option.label}
                      </SelectItem>
                    ))}
                  </SelectGroup>
                </SelectContent>
              </Select>
            </div>

            {timerDuration === 'custom' && (
              <div className='mt-3'>
                <label className='block text-sm font-medium text-gray-700 mb-2'>
                  Custom Date & Time
                </label>
                <input
                  type='datetime-local'
                  className='w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500'
                  value={customDateTime}
                  onChange={(e) => setCustomDateTime(e.target.value)}
                />
              </div>
            )}

            {timerDuration && timerDuration !== 'custom' && (
              <p className='mt-2 text-sm text-gray-500'>
                Order will be automatically unflagged at:{' '}
                {calculateUnflagAt()?.toLocaleString()}
              </p>
            )}

            {timerDuration === 'custom' && customDateTime && (
              <p className='mt-2 text-sm text-gray-500'>
                Order will be automatically unflagged at:{' '}
                {new Date(customDateTime).toLocaleString()}
              </p>
            )}

            <br />
          </div>
          <DialogFooter>
            <Button
              onClick={handleSubmit}
              disabled={
                !timerDuration ||
                (timerDuration === 'custom' && !customDateTime)
              }
            >
              Set On Hold
            </Button>
          </DialogFooter>
        </DialogContent>
      )}
    </Dialog>
  );
};

export default OnHoldWithTimerModal;
